(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reports', {
                parent: 'entity',
                url: '/reports',
                ncyBreadcrumb: {
                    label: 'Reports',
                    parent: 'entity'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Reports Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reports/reports.html',
                        controller: 'ReportsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                }
            })
    }
})();
